import React, { useState, useEffect } from 'react';
import VideoPlayerCtrl from './videoPlayerCtrl';
import ClonRVideo, { VideoGroup } from '../models/clonRVideo';
import CountryFlagCtrl from './countryFlagCtrl';


interface Props {
    id: string;
    videoGroup: VideoGroup
}


const VideoGroupPlayerCtrl: React.FC<Props> = ({ id, videoGroup }) => {

    const [selectedVideo, setSelectedVideo] = useState<ClonRVideo>(videoGroup.videos.length > 0 ? videoGroup.videos[0] : new ClonRVideo());

    // Function to get browser language and find matching video
    const getBrowserLanguageVideo = (): ClonRVideo | null => {
        const browserLanguage = navigator.language || navigator.languages?.[0] || 'en';
        const languageCode = browserLanguage.split('-')[0].toLowerCase(); // Get primary language code
        
        // Find a video that matches the browser language
        const matchingVideo = videoGroup.videos.find(v => 
            v.status === "finished" && 
            v.language.toLowerCase() === languageCode
        );
        
        return matchingVideo || null;
    };

    // Function to get reordered videos with browser language first
    const getReorderedVideos = (): ClonRVideo[] => {
        const browserLanguageVideo = getBrowserLanguageVideo();
        if (!browserLanguageVideo) {
            return videoGroup.videos; // Return original order if no match
        }

        // Reorder videos: browser language first, then the rest
        const otherVideos = videoGroup.videos.filter(v => v.id !== browserLanguageVideo.id);
        return [browserLanguageVideo, ...otherVideos];
    };

    // Set initial video based on browser language
    useEffect(() => {
        const browserLanguageVideo = getBrowserLanguageVideo();
        if (browserLanguageVideo) {
            setSelectedVideo(browserLanguageVideo);
        }
    }, [videoGroup]);

    const playVideo = () => {
        const vidElement = document.getElementById(id) as any;
        if (vidElement) {
            vidElement.play();
        }
    }

    const handleOnLanguageButtonClick = (video: ClonRVideo) => {
        setSelectedVideo(video);
        setTimeout(playVideo, 200);
    }

    // Get reordered videos for rendering
    const reorderedVideos = getReorderedVideos();

    return (
        <div className='kt-video-group-player-ctrl'>
            <VideoPlayerCtrl
                id={id}
                videoUrl={selectedVideo.videoUrl}
                thumbnailUrl={selectedVideo.thumbnailUrl}
            />

            {reorderedVideos.filter(v => v.status === "finished").length > 1 &&
                <div className='kt-language-buttons'>
                    {reorderedVideos.filter(v => v.status === "finished").map(v => v.id === selectedVideo.id ?
                        <span key={v.id} className='kt-language-button kt-large kt-selected' onClick={() => handleOnLanguageButtonClick(v)}>
                            <CountryFlagCtrl countryCode={v.language} />
                        </span>
                        :
                        <span key={v.id} className='kt-language-button kt-large' onClick={() => handleOnLanguageButtonClick(v)}>
                            <CountryFlagCtrl countryCode={v.language} />
                        </span>
                    )}
                </div>
            }

        </div >
    );
}

export default VideoGroupPlayerCtrl;